(function() {
  function initSizeValidation() {
    if (window.__sizeValidationInitialized) return;
    window.__sizeValidationInitialized = true;

    // --- Helpers ---
    const getSizeOptions = () =>
      document.querySelectorAll(
        '.product-form__input input[type="radio"][name*="Size"], .product-form__input input[type="radio"][name*="size"]'
      );

    const getAddToCartBtns = () =>
      document.querySelectorAll('.product-form__submit');

    // --- Error message (UNCHANGED LOGIC) ---
    const errorMsg = document.createElement('div');
    errorMsg.classList.add('size-error-close');
    errorMsg.innerHTML = '<span>&times;</span> Select a size before adding to cart.';
    errorMsg.style.color = '#000';
    errorMsg.style.fontSize = '14px';
    errorMsg.style.marginBottom = '10px';
    errorMsg.style.display = 'none';

    function insertErrorMsg() {
      const btns = getAddToCartBtns();
      if (
        btns.length &&
        !btns[0].previousSibling?.classList?.contains('size-error-close')
      ) {
        btns[0].parentNode.insertBefore(errorMsg, btns[0]);
      }
    }

    const isSizeSelected = () =>
      Array.from(getSizeOptions()).some(opt => opt.checked);

    const disableAddToCart = () =>
      getAddToCartBtns().forEach(btn => (btn.disabled = true));

    const enableAddToCart = () =>
      getAddToCartBtns().forEach(btn => (btn.disabled = false));

    // an option with ONE value (the mug's single 11 oz) has nothing to choose: it stays ticked (GarageWorn 2026-10-18)
    const isOnlyChoice = (opt) => {
      const fs = opt.closest('fieldset');
      return !!fs && fs.querySelectorAll('input[type="radio"]').length === 1;
    };

    const uncheckAllSizes = () =>
      getSizeOptions().forEach(opt => {
        if (isOnlyChoice(opt)) { opt.checked = true; return; }
        opt.checked = false;
        opt.removeAttribute('checked');
      });

    // --- State ---
    let forceDisabled = false;
    let sizeWasSelected = false;
    let colorTimeout;
    let blockInterval;

    // --- Initial setup ---
    insertErrorMsg();
    enableAddToCart(); // keep your original behavior
    setTimeout(() => { uncheckAllSizes(); sizeWasSelected = isSizeSelected(); }, 200);

    // --- Add to Cart click (UNCHANGED LOGIC) ---
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.product-form__submit');
      if (!btn) return;
      if (!getSizeOptions().length) return; // no Size option on this product (flag, mug, plate...) - nothing to check (GarageWorn 2026-10-15)

      if (!isSizeSelected()) {
        e.preventDefault();
        errorMsg.style.display = 'flex';
        disableAddToCart();
        forceDisabled = true;
        uncheckAllSizes(); // fixed bug
      } else {
        errorMsg.style.display = 'none';
        enableAddToCart();
        forceDisabled = false;
      }
    });

    // --- Change handler ---
    document.addEventListener('change', function(e) {
      const name = e.target?.name?.toLowerCase() || '';

      // --- SIZE ---
      if (name.includes('size')) {
        if (e.target.checked) {
          sizeWasSelected = true;

          errorMsg.style.display = 'none';
          enableAddToCart();
          forceDisabled = false;

          if (window.jQuery) jQuery('.name-variant').hide();
        } else {
          sizeWasSelected = false;

          disableAddToCart();
          errorMsg.style.display = 'flex';
          forceDisabled = true;
        }
        return;
      }

      // --- COLOR (FINAL NO AUTO-SELECT FIX) ---
     if (!name.includes('size')) {
        e.stopImmediatePropagation();

        clearTimeout(colorTimeout);
        clearInterval(blockInterval);

        // 🚨 Only block if size NOT selected
        if (!sizeWasSelected) {
          let attempts = 0;

          blockInterval = setInterval(() => {
            const sizes = getSizeOptions();

            sizes.forEach(opt => {
              if (opt.checked) {
                opt.checked = false;
                opt.removeAttribute('checked');
              }
            });

            attempts++;
            if (attempts > 15) {
              clearInterval(blockInterval);
            }
          }, 80);
        }

        colorTimeout = setTimeout(() => {
          if (!sizeWasSelected) {
            // disableAddToCart();
            // forceDisabled = true;
          } else {
            enableAddToCart();
            forceDisabled = false;
          }
        }, 900);

        return;
      }
    });

    // --- Observer ---
    const observer = new MutationObserver(() => {
      insertErrorMsg();

      if (forceDisabled && !isSizeSelected()) {
        disableAddToCart();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // --- Init ---
  window.addEventListener('load', () => {
    setTimeout(initSizeValidation, 800);
  });

  document.addEventListener('shopify:section:load', initSizeValidation);
})();